// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GMR4OyEVq45yO3kNUEo9{flex-direction:column;justify-content:center;align-items:center;height:100%;display:flex}.GMR4OyEVq45yO3kNUEo9 .s75mOyb9pwA8R559WYdw{background:var(--green-10);border-radius:100px;justify-content:center;align-items:center;width:80px;height:80px;display:flex}.GMR4OyEVq45yO3kNUEo9 .s75mOyb9pwA8R559WYdw ._3ogd5ZdnEHJkKPNEkK9{background:var(--green-70);border-radius:12px;width:32px;height:32px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `GMR4OyEVq45yO3kNUEo9`,
	"iconWrap": `s75mOyb9pwA8R559WYdw`,
	"icon": `_3ogd5ZdnEHJkKPNEkK9`
};
export default ___CSS_LOADER_EXPORT___;
